import { render, staticRenderFns } from "./ReceiveNew_Items.vue?vue&type=template&id=7527f138&"
import script from "./ReceiveNew_Items.vue?vue&type=script&lang=js&"
export * from "./ReceiveNew_Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports